/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReturnActionCode {
    SHOW_WORKFLOW = 'ShowWorkflow',
    SWITCH_TO_ORG = 'SwitchToOrg',
    SHOW_ERROR = 'ShowError',
}
